<script setup>
const handleJump = () => {
  window.location.href = 'https://www.racoondigi.cn/pages/MinorsPolicy.html'
}
</script>

<template>
<div class="footer_block">
  <img class="logo" src="@/assets/newPc/footer_logo.png" alt="">
  <div>
    <div class="font_24 mb15">
      <div class="mr40">抵制不良游戏</div>
      <div class="mr40">拒绝盗版游戏</div>
      <div class="mr40">注意自我保护</div>
      <div class="mr40">谨防上当受骗</div>
    </div>
    <div class="font_24 mb20">
      <div class="mr40">适度游戏益脑</div>
      <div class="mr40">沉迷游戏伤身</div>
      <div class="mr40">合理安排时间</div>
      <div class="mr40">享受健康生活</div>
    </div>
    <div class="font_20 mb15">
      <div class="mr40">沪ICP备14048124号-3 | ISBN 978-7-498-06027-3</div>
      <div>©2025 上海瑞酷数码科技有限公司版权所有</div>
    </div>
    <div class="font_20" style="cursor: pointer" @click="handleJump">客服电话：4006861056 家长监护工程</div>
  </div>
</div>
</template>

<style scoped lang="scss">
.footer_block {
  width: 100vw;
  height: 12.5vw;
  background: transparent url("@/assets/newPc/footer_bg.png") no-repeat center center;
  background-size: cover;
  padding: 0 0 0 25.46875vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;


  &>div {
    display: flex;
    flex-direction: column;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      left: -4.453125vw;
      bottom: 0.78125vw;
      top: 0.78125vw;
      background-color: #9C96AF;
      width: 1px;
    }


    &>div {
      display: flex;
      flex-direction: row;
      color: #9C96AF;

      div {
        color: #9C96AF;
      }
    }
  }

  .logo {
    width: 10.1953125vw;
    height: 5.625vw;
    margin-right: 8.1640625vw;
  }

  .font_24 {
    font-size: 0.9375vw;
  }

  .font_20 {
    font-size: 0.78125vw;
  }

  .mr40 {
    margin-right: 1.5625vw;
  }
  .mb15 {
    margin-bottom: 0.5859375vw;
  }
  .mb20 {
    margin-bottom: 0.78125vw;
  }
}
</style>